import { WithdrawalStatus } from '../../../@types/api';
import { WITHDRAWAL_STATUS_OPTIONS } from '../../../constants';
import useFilterForm from '../../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../../hooks/usePagination';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import FormSelect from '../../molecules/FormSelect';
import { DialogType } from '../../../@types';

export type FilterApprovalsData = {
  statuses?: WithdrawalStatus[];
};

export const defaultApprovalsFilters: FilterApprovalsData = {
  statuses: undefined,
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterApprovals = ({ changeQuery, closeModal }: Props) => {
  const { control, handleResetFilter, handleSubmit } = useFilterForm<FilterApprovalsData>({
    defaultData: defaultApprovalsFilters,
    changeQuery,
  });

  return (
    <FilterDialogLayout
      label='approvals'
      onSave={handleSubmit}
      onClose={() => closeModal?.()}
      onReset={handleResetFilter}
    >
      <FormSelect control={control} name='statuses' label='Status' options={WITHDRAWAL_STATUS_OPTIONS} />
    </FilterDialogLayout>
  );
};

export default FilterApprovals;
